export const ATLAS_InspectionConnectionReportSections = {
    rotorBlade: {
      

      heights: {
        header1: "auto",
        header2: "auto",
      },
      minDataRowsCount: 2,
      columns: [
        {
          title: "Rotor Blade Tests",
          colSpan: 20,
          rowSpan: 1,
          className: "tbl-text-normal",
          columns: [
            {
              title: "Test Description",
              colSpan: 7,
              rowSpan: 1,
              className: "tbl-text-normal",
              accessor: "testDescription",
              dataClassName: "text-left pd-left-10px d-block",
            },
            {
              title: "Results of Test",
              colSpan: 3,
              rowSpan: 1,
              className: "tbl-text-normal",
              accessor: "summary.test",
            },
            {
              title: "Comments",
              colSpan: 10,
              rowSpan: 1,
              className: "tbl-text-normal",
              dataClassName: "text-left pd-left-10px d-block",
              accessor: "summary.com",
            },
          ],
        },
      ],
    },


    rotorBladeTable: {
      heights: {
        header1: "auto",
        header2: "auto",
      },
      minDataRowsCount: 2,
      
          columns: [
            {
              title: "Rotor Blade Torque Screw",
              colSpan: 5,
              rowSpan: 1,
              className: "tbl-text-normal",
              accessor: "circ",
              dataClassName: "text-left pd-left-10px d-block",
            },
            {
              title: "Torque",
              colSpan: 5,
              rowSpan: 1,
              className: "tbl-text-normal",
              accessor: "mode",
            },
          
          ],
       
    },


    driveTrainTable: {
      heights: {
        header1: "auto",
        header2: "auto",
      },
      minDataRowsCount: 2,
      
          columns: [
            {
              title: "Drive Train Torque Screw",
              colSpan: 5,
              rowSpan: 1,
              className: "tbl-text-normal",
              accessor: "circ",
              dataClassName: "text-left pd-left-10px d-block",
            },
            {
              title: "Torque",
              colSpan: 5,
              rowSpan: 1,
              className: "tbl-text-normal",
              accessor: "mode",
            },
          
          ],
       
    },


    supportStructureTable: {
      heights: {
        header1: "auto",
        header2: "auto",
      },
      minDataRowsCount: 2,
      
          columns: [
            {
              title: "Support Structure Torque Screw",
              colSpan: 5,
              rowSpan: 1,
              className: "tbl-text-normal",
              accessor: "circ",
              dataClassName: "text-left pd-left-10px d-block",
            },
            {
              title: "Torque",
              colSpan: 5,
              rowSpan: 1,
              className: "tbl-text-normal",
              accessor: "mode",
            },
          
          ],
       
    },

    driveTrain: {
        heights: {
          header1: "auto",
          header2: "auto",
        },
        minDataRowsCount: 2,
        columns: [
          {
            title: "Drive Train Tests",
            colSpan: 20,
            rowSpan: 1,
            className: "tbl-text-normal",
            columns: [
              {
                title: "Test Description",
                colSpan: 7,
                rowSpan: 1,
                className: "tbl-text-normal",
                accessor: "testDescription",
                dataClassName: "text-left pd-left-10px d-block",
              },
              {
                title: "Results of Test",
                colSpan: 3,
                rowSpan: 1,
                className: "tbl-text-normal",
                accessor: "summary.test",
              },
              {
                title: "Comments",
                colSpan: 10,
                rowSpan: 1,
                className: "tbl-text-normal",
                dataClassName: "text-left pd-left-10px d-block",
                accessor: "summary.com",
              },
            ],
          },
        ],
      },


      supportStructure: {
        heights: {
          header1: "auto",
          header2: "auto",
        },
        minDataRowsCount: 2,
        columns: [
          {
            title: "Support Structure Tests",
            colSpan: 20,
            rowSpan: 1,
            className: "tbl-text-normal",
            columns: [
              {
                title: "Test Description",
                colSpan: 7,
                rowSpan: 1,
                className: "tbl-text-normal",
                accessor: "testDescription",
                dataClassName: "text-left pd-left-10px d-block",
              },
              {
                title: "Results of Test",
                colSpan: 3,
                rowSpan: 1,
                className: "tbl-text-normal",
                accessor: "summary.test",
              },
              {
                title: "Comments",
                colSpan: 10,
                rowSpan: 1,
                className: "tbl-text-normal",
                dataClassName: "text-left pd-left-10px d-block",
                accessor: "summary.com",
              },
            ],
          },
        ],
      },

}
//     quarterly: {
//       heights: {
//         header1: "auto",
//         header2: "auto",
//       },
//       minDataRowsCount: 3,
//       columns: [
//         {
//           title: "Quarterly Tests",
//           colSpan: 20,
//           rowSpan: 1,
//           className: "tbl-text-normal",
//           columns: [
//             {
//               title: "Test Description & Rule",
//               colSpan: 7,
//               rowSpan: 1,
//               className: "tbl-text-normal",
//               accessor: "testDescription",
//               dataClassName: "text-left pd-left-10px d-block",
//             },
//             {
//               title: "Condition Left",
//               colSpan: 3,
//               rowSpan: 1,
//               className: "tbl-text-normal",
//               accessor: "summary.test",
//             },
//             {
//               title: "Comments",
//               colSpan: 10,
//               rowSpan: 1,
//               className: "tbl-text-normal",
//               dataClassName: "text-left pd-left-10px d-block",
//               accessor: "summary.com",
//             },
//           ],
//         },
//       ],
//     },
//   };
  


// WEBPACK FOOTER //
// ./src/components/Reports/ATLAS/InspectionConnectionReport/ATLAS_InspectionConnectionReportSchema.js